import { useQuery } from '@tanstack/react-query';
import { getSectorChartsData, SectorChartsResponse } from '../../services/network/form30SectorCharts-api';

interface UseFetchSectorChartsParams {
    year: number | null;
    sector_id: string | null;
    enabled?: boolean;
}

export const useFetchSectorCharts = ({
    year,
    sector_id,
    enabled = true
}: UseFetchSectorChartsParams) => {
    const shouldFetch = enabled && !!year && !!sector_id;

    const { data, isLoading, isError, error, refetch } = useQuery<SectorChartsResponse>({
        queryKey: ['sectorCharts', year, sector_id],
        queryFn: async () => {
            if (!year || !sector_id) {
                throw new Error('Отсутствуют обязательные параметры');
            }
            return await getSectorChartsData(year, sector_id);
        },
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });

    return {
        sectorChartsData: data?.data || null,
        physicalGroupsData: data?.data?.physicalGroups || null,
        healthGroupsData: data?.data?.healthGroups || null,
        rehabilitationData: data?.data?.rehabilitation || null,
        childCountData: data?.data?.childCount || null,
        metricsData: data?.data?.metrics || null,
        isLoading,
        isError,
        error,
        refetch
    };
};
